<section class="platform-page redesign-page token-page">
  <!-- ===== Token hero ===================================================== -->
  <header class="thero">
    <div class="thero__main">
      <app-token-logo
        [logoUrl]="tokenLogoUrl()"
        [label]="displayName()"
        size="lg"
      />

      <div class="thero__id">
        <div class="thero__row">
          @if (tokenInfoLoading() && !appMetadata()) {
            <kc-skeleton width="180px" height="28px" variant="text" />
          }
          @if (!tokenInfoLoading() || appMetadata()) {
            <h1 [title]="heroTitle()">
              {{ heroTitle() }}
            </h1>
          }
          <span class="thero__tk">{{
            appMetadata()?.ticker ||
              selectedMarket()?.metadata?.ticker ||
              nativeTicker() ||
              'TOKEN'
          }}</span>
          <span class="thero__px mono">
            {{ midPriceLabel() }} <span class="muted small">KAS</span>
          </span>
          @if (priceChangeLabel(); as change) {
            <span
              class="thero__chg"
              [class.up]="priceChangeUp()"
              [class.down]="!priceChangeUp()"
              >{{ change }}</span
            >
          }
        </div>
        @if (tokenSubtitle(); as subtitle) {
          <p class="thero__sub">
            {{ subtitle }}
          </p>
        }
        @if (tokenLinks().length) {
          <div class="thero__pills">
            @for (link of tokenLinks(); track link) {
              <a
                class="thero__tk social-link"
                [href]="link.href"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="link.label"
                [kcTooltip]="link.label"
                tooltipPosition="top-center"
              >
                <svg
                  class="social-link__icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  focusable="false"
                >
                  @switch (link.icon) {
                    @case ('website') {
                      <path
                        fill="currentColor"
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
                      />
                    }
                    @case ('x') {
                      <path
                        fill="currentColor"
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                      />
                    }
                    @case ('telegram') {
                      <path
                        fill="currentColor"
                        d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
                      />
                    }
                    @case ('discord') {
                      <path
                        fill="currentColor"
                        d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"
                      />
                    }
                    @case ('github') {
                      <path
                        fill="currentColor"
                        d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
                      />
                    }
                    @case ('medium') {
                      <path
                        fill="currentColor"
                        d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"
                      />
                    }
                  }
                </svg>
              </a>
            }
          </div>
        }
        <div class="thero__pills">
          <button
            type="button"
            class="id-pill"
            [class.id-pill--copied]="headerIdCopied('token')"
            [kcTooltip]="
              headerIdCopied('token')
                ? 'Copied'
                : 'Token ID (covenant ID) — the primary identity of this token. Click to copy the full value.'
            "
            [attr.aria-label]="'Copy token ID (covenant ID) ' + covenantId()"
            (click)="copyHeaderId('token', covenantId())"
          >
            <span class="id-pill__kind">Token ID</span>
            <span class="id-pill__value">{{ shortId(covenantId()) }}</span>
            <span class="id-pill__icon" aria-hidden="true">{{
              headerIdCopied('token') ? '✓' : '⧉'
            }}</span>
          </button>
          @if (wrappedMarketId(); as marketId) {
            <button
              type="button"
              class="id-pill"
              [class.id-pill--copied]="headerIdCopied('market')"
              [kcTooltip]="
                headerIdCopied('market')
                  ? 'Copied'
                  : 'Market ID — the wrapped trading market for this token. Click to copy the full value.'
              "
              [attr.aria-label]="'Copy market ID ' + marketId"
              (click)="copyHeaderId('market', marketId)"
            >
              <span class="id-pill__kind">Market ID</span>
              <span class="id-pill__value">{{ shortId(marketId) }}</span>
              <span class="id-pill__icon" aria-hidden="true">{{
                headerIdCopied('market') ? '✓' : '⧉'
              }}</span>
            </button>
          }
          <kc-button
            [class]="
              statusTagClass(
                wrapperEnabled() ? TagStatus.SUCCESS : TagStatus.NEUTRAL
              )
            "
            variant="tag"
            size="s"
            [text]="wrapperEnabled() ? 'Wrapped active' : 'Read only'"
            [isSelected]="
              statusTagSelected(
                wrapperEnabled() ? TagStatus.SUCCESS : TagStatus.NEUTRAL
              )
            "
            [isDisabled]="true"
          />
          @if (feeTicketFeatureEnabled() && wrapperFeeTicketSupported()) {
            <kc-button
              [class]="statusTagClass(TagStatus.INFO)"
              variant="tag"
              size="s"
              text="Coupons supported"
              [isSelected]="statusTagSelected(TagStatus.INFO)"
              [isDisabled]="true"
            />
          }
          @if (mintable()) {
            <kc-button
              [class]="statusTagClass(TagStatus.INFO)"
              variant="tag"
              size="s"
              [text]="mintBadgeText()"
              [isSelected]="statusTagSelected(TagStatus.INFO)"
              [isDisabled]="true"
            />
          }
        </div>
      </div>
    </div>

    <div class="thero__actions">
      @if (showWatchButton()) {
        <kc-button
          variant="secondary"
          size="m"
          [text]="watching() ? 'Watching' : 'Watch'"
          [isDisabled]="watchButtonDisabled()"
          (buttonClick)="toggleWatch()"
        />
      }
      @if (canManageMetadata()) {
        <kc-button
          variant="secondary"
          size="m"
          text="Manage"
          [routerLink]="['/tokens', covenantId(), 'manage']"
        />
      }
    </div>
  </header>

  @if (!owner()) {
    <kc-alert
      variant="warning"
      text="Connect your wallet to trade, mint, or manage this token."
      actionLabel="Connect"
      (actionClick)="walletManager.requestLoginModal()"
    />
  }

  <!-- The href keeps a semantic in-page anchor (and a no-JS fallback), but the
       click handler owns the real navigation: it switches the owning tab and
       scrolls the `.route-content` container, which a bare fragment jump can't
       do. -->
  <nav class="mobile-section-tabs" aria-label="Token page sections">
    <a href="#token-orderbook" (click)="scrollToSection('orderbook', $event)"
      >Orderbook</a
    >
    <a href="#token-trade" (click)="scrollToSection('trade', $event)">Trade</a>
    <a href="#token-stats" (click)="scrollToSection('stats', $event)">Stats</a>
    <a
      href="#token-trading-activity"
      (click)="scrollToSection('tradingActivity', $event)"
      >Trading Activity</a
    >
    <a
      href="#token-token-activity"
      (click)="scrollToSection('tokenActivity', $event)"
      >Token Activity</a
    >
    <a href="#token-holders" (click)="scrollToSection('holders', $event)"
      >Holders</a
    >
  </nav>

  <!-- ===== Metric strip ================================================== -->
  <section id="token-stats" class="metrics">
    <div class="kc-linear-left">
      <article class="metric kc-linear-glow-left">
        <div class="metric__k">24h volume</div>
        @if (tokenInfoLoading()) {
          <kc-skeleton width="70px" height="24px" variant="text" />
        }
        @if (!tokenInfoLoading()) {
          <div class="metric__v">
            {{ volume24hLabel() }}
          </div>
        }
      </article>
    </div>
    <div class="kc-linear-left">
      <article class="metric kc-linear-glow-left">
        <div class="metric__k">Market Cap</div>
        @if (tokenInfoLoading()) {
          <kc-skeleton width="70px" height="24px" variant="text" />
        }
        @if (!tokenInfoLoading()) {
          <div class="metric__v">
            {{ marketCapFloorLabel() }}
          </div>
        }
      </article>
    </div>
    <div class="kc-linear-left">
      <article class="metric kc-linear-glow-left">
        <div class="metric__k">Holders</div>
        @if (tokenInfoLoading()) {
          <kc-skeleton width="70px" height="24px" variant="text" />
        }
        @if (!tokenInfoLoading()) {
          <div class="metric__v">
            {{ holdersLabel() }}
          </div>
        }
      </article>
    </div>
    <div class="kc-linear-right">
      <article class="metric kc-linear-glow-right">
        <div class="metric__k">Open orders</div>
        @if (tokenInfoLoading() && !selectedMarket()) {
          <kc-skeleton width="70px" height="24px" variant="text" />
        }
        @if (selectedMarket()) {
          <div class="metric__v">
            {{ formatCount(openOrderCount()) }}
          </div>
        }
        @if (!selectedMarket() && !tokenInfoLoading()) {
          <div class="metric__v">--</div>
        }
      </article>
    </div>
    <div class="kc-linear-right">
      <article class="metric kc-linear-glow-right">
        <div class="metric__k">Total trades</div>
        @if (tokenInfoLoading()) {
          <kc-skeleton width="70px" height="24px" variant="text" />
        }
        @if (!tokenInfoLoading()) {
          <div class="metric__v">
            {{ totalTradesLabel() }}
          </div>
        }
      </article>
    </div>
  </section>

  <!-- ===== Cockpit grid ================================================== -->
  <div class="tgrid">
    <div class="left-col">
      <!-- Price chart -->
      <div class="kc-linear-left tpanel-wrap">
        <app-price-chart
          id="token-chart"
          [candles]="candles()"
          [intervalMs]="chartIntervalMs()"
          [loading]="chartLoading()"
          subtitle="OHLCV · wrapped market"
          (intervalChange)="setChartInterval($event)"
          (rangeRequest)="loadOlderCandles($event)"
        />
      </div>

      <!-- Trading Activity / Token Activity / Holders / Position
           Nested under left-col on desktop so the book/trade columns cannot
           insert free space between chart and activity (grid row stretch). -->
      <div class="kc-linear-left tpanel-wrap activity-wrap">
        <article class="tpanel kc-linear-glow-left">
          <nav class="tabs" aria-label="Token lower sections">
            <button
              id="token-trading-activity"
              type="button"
              [class.active]="lowerTab() === 'tradingActivity'"
              (click)="setLowerTab('tradingActivity')"
            >
              Trading Activity
            </button>
            <button
              id="token-token-activity"
              type="button"
              [class.active]="lowerTab() === 'tokenActivity'"
              (click)="setLowerTab('tokenActivity')"
            >
              Token Activity
            </button>
            <button
              id="token-holders"
              type="button"
              [class.active]="lowerTab() === 'holders'"
              (click)="setLowerTab('holders')"
            >
              Holders
            </button>
            <button
              type="button"
              [class.active]="lowerTab() === 'position'"
              (click)="setLowerTab('position')"
            >
              Your position
            </button>
            <button
              type="button"
              [class.active]="lowerTab() === 'orders'"
              (click)="setLowerTab('orders')"
            >
              Open orders
            </button>
          </nav>

          @if (lowerTab() === 'tradingActivity') {
            <div class="activity-body" #activityBody>
              @if (!activityLoading() && !activityRows().length) {
                <app-empty-state
                  class="flat-empty-state"
                  title="No trading activity yet"
                  subtitle="Buy and sell trades for this token will appear here once orders start filling."
                  iconClass="history"
                  size="md"
                  backgroundColor="transparent"
                />
              } @else {
                <kc-table
                  [columns]="
                    activityColumns(
                      activityActionCell,
                      activityWhoCell,
                      activityAmountCell,
                      activityUnitPriceCell,
                      activityTotalCell,
                      activityTxCell,
                      activityTimeCell
                    )
                  "
                  [data]="activityRows()"
                  [isLoading]="activityLoading() && !activityRows().length"
                  [skeletonRows]="8"
                  [stripedRows]="false"
                  [rowTrackBy]="trackActivity"
                  [enablePagination]="false"
                  emptyMessage="No trading activity yet"
                  minWidth="820px"
                  maxHeight="100%"
                />
                @if (activityHasNextPage()) {
                  <button
                    type="button"
                    class="activity-loadmore"
                    [disabled]="activityLoadingMore()"
                    (click)="loadMoreActivity()"
                  >
                    {{ activityLoadingMore() ? 'Loading…' : 'Load more' }}
                  </button>
                }
              }
            </div>
          }

          @if (lowerTab() === 'tokenActivity') {
            <div class="activity-body" #tokenActivityBody>
              @if (!tokenActivityLoading() && !tokenActivityRows().length) {
                <app-empty-state
                  class="flat-empty-state"
                  title="No token activity yet"
                  subtitle="Mint, deploy, and transfer operations for this token will appear here."
                  iconClass="history"
                  size="md"
                  backgroundColor="transparent"
                />
              } @else {
                <kc-table
                  [columns]="
                    activityColumns(
                      activityActionCell,
                      activityWhoCell,
                      activityAmountCell,
                      activityUnitPriceCell,
                      activityTotalCell,
                      activityTxCell,
                      activityTimeCell
                    )
                  "
                  [data]="tokenActivityRows()"
                  [isLoading]="
                    tokenActivityLoading() && !tokenActivityRows().length
                  "
                  [skeletonRows]="8"
                  [stripedRows]="false"
                  [rowTrackBy]="trackActivity"
                  [enablePagination]="false"
                  emptyMessage="No token activity yet"
                  minWidth="820px"
                  maxHeight="100%"
                />
                @if (tokenActivityHasNextPage()) {
                  <button
                    type="button"
                    class="activity-loadmore"
                    [disabled]="tokenActivityLoadingMore()"
                    (click)="loadMoreTokenOpsActivity()"
                  >
                    {{ tokenActivityLoadingMore() ? 'Loading…' : 'Load more' }}
                  </button>
                }
              }
            </div>
          }

          @if (lowerTab() === 'holders') {
            <div class="holder-list">
              <div class="holder-row holder-row--head">
                <span class="holder-col-title">
                  Holders
                  @if (holdersCountLabel(); as count) {
                    <span class="holder-col-count">({{ count }})</span>
                  }
                </span>
                <span>Amount</span><span>Share</span><span>UTXOs</span>
              </div>
              <div class="holder-list__scroll" #holdersBody>
                @for (entry of rankedHolders(); track entry.rank) {
                  <div class="holder-row">
                    <span
                      class="holder-owner"
                      [title]="holderOwnerTitle(entry.holder)"
                    >
                      <span class="holder-owner__rank">{{ entry.rank }}</span>
                      <span class="holder-owner__body">
                        <span class="holder-owner__line">
                          <span class="holder-owner__primary mono">
                            @if (holderLabelUsesAddressTruncate(entry.holder)) {
                              {{
                                holderDisplayLabel(entry.holder)
                                  | truncateWalletAddress: 10 : 6
                              }}
                            } @else {
                              {{ holderDisplayLabel(entry.holder) }}
                            }
                          </span>
                          @if (holderCopyValue(entry.holder); as copyValue) {
                            <button
                              type="button"
                              class="holder-copy-btn"
                              [class.holder-copy-btn--copied]="
                                holderCopyCopied(entry.rank)
                              "
                              [attr.aria-label]="
                                holderCopyCopied(entry.rank)
                                  ? 'Copied'
                                  : 'Copy ' + holderDisplayLabel(entry.holder)
                              "
                              (click)="
                                copyHolderValue(entry.rank, copyValue);
                                $event.stopPropagation()
                              "
                            >
                              <kc-icon
                                size="xs"
                                class="holder-copy-icon"
                                [iconClass]="
                                  holderCopyCopied(entry.rank)
                                    ? 'check'
                                    : 'copy-03'
                                "
                                [isDefaultColor]="false"
                              />
                            </button>
                          }
                        </span>
                      </span>
                    </span>
                    <span class="mono">{{
                      entry.holder.amount | kcc20TokenAmount: tokenDecimals()
                    }}</span>
                    <span>{{ holderShareLabel(entry.holder) }}</span>
                    <span class="mono">{{
                      formatCount(entry.holder.utxoCount)
                    }}</span>
                  </div>
                }
                @if (holdersLoading() && !holders().length) {
                  <div class="panel-loading">
                    <kc-loader kind="dots" size="md" label="Loading holders" />
                    <span>Loading holders</span>
                  </div>
                }
                @if (!holdersLoading() && !holders().length) {
                  <app-empty-state
                    title="No holder rows yet"
                    subtitle="Holder distribution will appear once indexed for this token."
                  />
                }
                @if (holdersHasNextPage()) {
                  <button
                    type="button"
                    class="activity-loadmore"
                    [disabled]="holdersLoadingMore()"
                    (click)="loadMoreHolders()"
                  >
                    {{ holdersLoadingMore() ? 'Loading…' : 'Load more' }}
                  </button>
                }
              </div>
            </div>
          }

          @if (lowerTab() === 'position') {
            <div class="position-panel">
              @for (warning of ownerHoldingsWarnings(); track warning) {
                <kc-alert variant="warning" [text]="warning" />
              }
              @if (ownerHoldingsLoading()) {
                <div class="panel-loading">
                  <kc-loader kind="dots" size="md" label="Loading holdings" />
                  <span>Loading holdings</span>
                </div>
              }
              @if (ownerHasTokenHoldings()) {
                <dl class="dl">
                  <div>
                    <dt>Assets · KCC20</dt>
                    <dd>
                      {{
                        ownerCanonicalBalance()
                          | kcc20TokenAmount: tokenDecimals()
                      }}
                    </dd>
                  </div>
                  <div>
                    <dt>Trading · DEX Orderbook</dt>
                    <dd class="accent">
                      {{
                        ownerWrappedBalance()
                          | kcc20TokenAmount: tokenDecimals()
                      }}
                    </dd>
                  </div>
                  <div>
                    <dt>Open orders</dt>
                    <dd>{{ formatCount(ownerPosition()?.openOrderCount) }}</dd>
                  </div>
                  <div>
                    <dt>Ask exposure</dt>
                    <dd>
                      {{
                        ownerPosition()?.openAskAmount
                          | kcc20TokenAmount: tokenDecimals()
                      }}
                    </dd>
                  </div>
                  <div>
                    <dt>Bid exposure</dt>
                    <dd>
                      {{
                        ownerPosition()?.openBidAmount
                          | kcc20TokenAmount: tokenDecimals()
                      }}
                    </dd>
                  </div>
                  <div>
                    <dt>Last change</dt>
                    <dd>{{ formatDateMs(ownerLastChangeMs()) }}</dd>
                  </div>
                </dl>
              }
              @if (!owner() && !ownerHoldingsLoading()) {
                <app-empty-state
                  class="flat-empty-state"
                  title="Connect wallet to see position"
                  subtitle="Your Assets, Trading assets, and open order exposure for this token will appear here."
                  iconClass="wallet-03"
                  size="md"
                  backgroundColor="transparent"
                  actionText="Connect wallet"
                  (action)="walletManager.requestLoginModal()"
                />
              }
              @if (
                owner() && !ownerHoldingsLoading() && !ownerHasTokenHoldings()
              ) {
                <app-empty-state
                  title="No position for this wallet"
                  subtitle="This wallet has no indexed balance or order exposure for this token yet."
                  size="md"
                />
              }
            </div>
          }

          @if (lowerTab() === 'orders') {
            <div
              id="token-orders"
              class="activity-body open-orders-body"
              #openOrdersBody
            >
              @if (!owner()) {
                <app-empty-state
                  class="flat-empty-state"
                  title="Connect wallet to see open orders"
                  subtitle="Your resting buy and sell orders for this token will appear here so you can cancel them."
                  iconClass="wallet-03"
                  size="md"
                  backgroundColor="transparent"
                  actionText="Connect wallet"
                  (action)="walletManager.requestLoginModal()"
                />
              } @else if (openOrdersError(); as ordersError) {
                <kc-alert variant="warning" [text]="ordersError" />
              } @else if (
                !openOrdersLoading() && !displayedOpenOrders().length
              ) {
                <app-empty-state
                  class="flat-empty-state"
                  title="No open orders for this token"
                  subtitle="Your resting buy and sell orders for this token will appear here so you can cancel them."
                  iconClass="bars-20px"
                  size="md"
                  backgroundColor="transparent"
                />
              } @else {
                <kc-table
                  [columns]="
                    openOrderColumns(
                      openOrderSideCell,
                      openOrderAmountCell,
                      openOrderPriceCell,
                      openOrderTotalCell,
                      openOrderTimeCell,
                      openOrderIdCell,
                      openOrderCancelCell
                    )
                  "
                  [data]="displayedOpenOrders()"
                  [isLoading]="
                    openOrdersLoading() && !displayedOpenOrders().length
                  "
                  [skeletonRows]="4"
                  [stripedRows]="false"
                  [rowTrackBy]="trackOpenOrder"
                  [enablePagination]="false"
                  emptyMessage="No open orders for this token"
                  minWidth="720px"
                  maxHeight="100%"
                  (sortChange)="onOpenOrdersSortChange($event)"
                />
                @if (openOrdersHasNextPage()) {
                  <button
                    type="button"
                    class="activity-loadmore"
                    [disabled]="openOrdersLoadingMore()"
                    (click)="loadMoreOpenOrders()"
                  >
                    {{ openOrdersLoadingMore() ? 'Loading…' : 'Load more' }}
                  </button>
                }
              }
            </div>
          }
        </article>
      </div>
    </div>
    <!-- /.left-col -->

    <!-- Orderbook / Mint / Wrap -->
    <div class="kc-linear-right tpanel-wrap bookcol">
      <article id="token-orderbook" class="tpanel kc-linear-glow-right">
        <nav class="tabs" aria-label="Token action sections">
          <button
            type="button"
            [class.active]="actionTab() === 'book'"
            (click)="setActionTab('book')"
          >
            Orderbook
          </button>
          <button
            type="button"
            [class.active]="actionTab() === 'mint'"
            (click)="setActionTab('mint')"
          >
            Mint
          </button>
          <button
            type="button"
            [class.active]="actionTab() === 'wrap'"
            (click)="setActionTab('wrap')"
          >
            Wrap
          </button>
        </nav>

        <!-- Orderbook -->
        @if (actionTab() === 'book') {
          <div class="book">
            @if (
              orderbook() && !depthAsksDisplay().length && !depthBids().length
            ) {
              <app-empty-state
                class="flat-empty-state"
                title="No open orders yet"
                subtitle="Be the first to place a buy or sell order for this token."
                iconClass="bars-20px"
                size="md"
                backgroundColor="transparent"
              />
            } @else {
              <div class="book__head">
                <span>Price (KAS)</span><span>Amount</span><span>Orders</span>
              </div>
              @for (
                ask of depthAsksDisplay();
                track trackByDepthPrice($index, ask)
              ) {
                <button
                  type="button"
                  class="book__row ask"
                  [class.sel]="isSelectedDepthLevel(ask, 'ask')"
                  [style.--depth]="ask.depthPct + '%'"
                  (click)="selectOrderbookLevel(ask, 'ask')"
                >
                  <span class="px">{{
                    priceBare(ask.level.unitPriceSompi)
                  }}</span>
                  <span class="amt">{{
                    ask.level.tokenAmount | kcc20TokenAmount: tokenDecimals()
                  }}</span>
                  <span class="ord">{{ ask.level.orderCount }}</span>
                </button>
              }
              @if (orderbook() && !depthAsksDisplay().length) {
                <div class="book-empty">No asks</div>
              }
              <div class="book__mid">
                <span class="px">{{ midPriceLabel() }}</span>
                <span class="spread" [attr.title]="spreadAmountLabel() || null"
                  >spread {{ spreadLabel() }}</span
                >
              </div>
              @for (bid of depthBids(); track trackByDepthPrice($index, bid)) {
                <button
                  type="button"
                  class="book__row bid"
                  [class.sel]="isSelectedDepthLevel(bid, 'bid')"
                  [style.--depth]="bid.depthPct + '%'"
                  (click)="selectOrderbookLevel(bid, 'bid')"
                >
                  <span class="px">{{
                    priceBare(bid.level.unitPriceSompi)
                  }}</span>
                  <span class="amt">{{
                    bid.level.tokenAmount | kcc20TokenAmount: tokenDecimals()
                  }}</span>
                  <span class="ord">{{ bid.level.orderCount }}</span>
                </button>
              }
              @if (orderbook() && !depthBids().length) {
                <div class="book-empty">No bids</div>
              }
            }
            @if (orderbookLoading() && !orderbook()) {
              <kc-loader-skeleton
                style="display: block; padding: 8px 16px 12px"
                preset="orderbook"
                [rows]="6"
                label="Loading orderbook depth"
              />
            }
            @if (!orderbookLoading() && !orderbook() && wrappedMarketId()) {
              <app-empty-state
                class="flat-empty-state"
                title="Order book unavailable"
                subtitle="We couldn't load the order book for this token. Try refreshing the page."
                tone="warning"
                size="md"
                backgroundColor="transparent"
              />
            }
          </div>
        }

        <!-- Mint -->
        @if (actionTab() === 'mint') {
          <div class="action-body">
            <div class="between">
              <kc-button
                [class]="
                  statusTagClass(
                    mintable() ? TagStatus.SUCCESS : TagStatus.NEUTRAL
                  )
                "
                variant="tag"
                size="s"
                [text]="mintable() ? mintBadgeText() : 'Not mintable'"
                [isSelected]="
                  statusTagSelected(
                    mintable() ? TagStatus.SUCCESS : TagStatus.NEUTRAL
                  )
                "
                [isDisabled]="true"
              />
              <span class="muted"
                >{{
                  tokenDetail()?.supply?.remainingMintSupply
                    | kcc20TokenAmount: tokenDecimals() : 'full' : '--' : 5
                }}
                remaining</span
              >
            </div>
            @if (publicMintControlSupported() && publicMintOwner()) {
              <div class="ftrow">
                <span class="ftrow__label">Mint status</span>
                <span class="ftrow__control">
                  <small class="muted">
                    {{ displayedPublicMintActive() ? 'Active' : 'Paused' }}
                  </small>
                  <kc-toggle
                    size="sm"
                    name="publicMintActive"
                    ariaLabel="Public mint availability"
                    [ngModel]="displayedPublicMintActive()"
                    [isDisabled]="mintAvailabilityUpdating()"
                    (ngModelChange)="setPublicMintActive($event)"
                  />
                </span>
              </div>
            }
            @if (mintable()) {
              <div class="wrapflow__side">
                <kc-loader-ring
                  size="sm"
                  [value]="mintedPct()"
                  label="Minted supply progress"
                />
                <div style="display: grid; flex: 1; min-width: 0; gap: 8px">
                  <div class="between">
                    <span class="muted small">Minted supply</span>
                    <span class="mono small">{{ mintedPct() }}%</span>
                  </div>
                  <kc-loader-bar
                    [value]="mintedPct()"
                    label="Minted supply progress"
                  />
                </div>
              </div>
            }
            <dl class="dl">
              <div>
                <dt>Mint price</dt>
                <dd>
                  {{
                    formatSompi(
                      tokenDetail()?.mintPolicy?.mintPricePerTokenSompi
                    )
                  }}
                </dd>
              </div>
              <div>
                <dt>Minted</dt>
                <dd>
                  {{
                    tokenDetail()?.supply?.mintedSupply
                      | kcc20TokenAmount: tokenDecimals() : 'full' : '--' : 5
                  }}
                </dd>
              </div>
              <div>
                <dt>Remaining</dt>
                <dd>
                  {{
                    tokenDetail()?.supply?.remainingMintSupply
                      | kcc20TokenAmount: tokenDecimals() : 'full' : '--' : 5
                  }}
                </dd>
              </div>
              <div>
                <dt>Max supply</dt>
                <dd>
                  {{
                    tokenDetail()?.supply?.maxSupply
                      | kcc20TokenAmount: tokenDecimals() : 'full' : '--' : 5
                  }}
                </dd>
              </div>
              <div>
                <dt>Total cost</dt>
                <dd class="accent">
                  {{
                    formatSompi(
                      mintTotalCostSompi()?.toString(),
                      kasDisplayMaxDecimals
                    )
                  }}
                </dd>
              </div>
            </dl>
            @if (visibleMintActionBlock(); as mintBlock) {
              <kc-alert variant="warning" [text]="mintBlock" />
            }
            @if (!publicMintPaused() || publicMintOwner()) {
              <div class="field">
                <label>Amount to mint</label>
                <kc-number-input
                  [ngModel]="mintAmount()"
                  (ngModelChange)="onMintAmountChange($event)"
                  [enforceEthersFormat]="false"
                  [max]="publicMintMaxAmount"
                  [suffixTemplate]="amtSuffix"
                />
                @if (minMintTokenAmount(); as minAmount) {
                  <span class="muted small"
                    >Min {{ minAmount }} {{ displayName() }} (~{{
                      minPaidMintKasLabel
                    }}
                    KAS)</span
                  >
                }
              </div>
              @if (
                mintAmountWarningsSettled() && mintAdjustedAmountMessage();
                as adjustedMessage
              ) {
                <kc-alert variant="warning" [text]="adjustedMessage" />
              }
              @if (
                mintAmountWarningsSettled() && mintAmountCapError();
                as capError
              ) {
                <kc-alert variant="warning" [text]="capError" />
              }
              @if (
                mintAmountWarningsSettled() && mintRemainingSupplyError();
                as remainingError
              ) {
                <kc-alert variant="warning" [text]="remainingError" />
              }

              <div class="trade-actions">
                <span class="action-tip" [kcTooltip]="connectWalletTooltip()">
                  <kc-button
                    variant="primary"
                    size="m"
                    [text]="
                      mintBalanceChecking()
                        ? 'Checking balance…'
                        : mintBalanceError()
                          ? 'Insufficient balance'
                          : 'Mint'
                    "
                    [isDisabled]="
                      !mintDraftReady() ||
                      !!mintBalanceError() ||
                      mintBalanceChecking()
                    "
                    (buttonClick)="buildMint()"
                  />
                </span>
              </div>
            }
          </div>
        }

        <!-- Wrap -->
        @if (actionTab() === 'wrap') {
          <div class="action-body">
            <!-- Wrapper/wrap/unwrap/deploy status is a single toast (see
                 `wrapStatus` -> notifications 'wrap') so at most one message
                 shows at a time instead of stacking multiple kc-alerts. -->
            @if (!wrappedMarketId()) {
              <div class="field">
                <label>Initial wrapped root amount</label>
                <kc-number-input
                  [ngModel]="wrapperDeployRootAmount()"
                  (ngModelChange)="wrapperDeployRootAmount.set($event)"
                  [enforceEthersFormat]="false"
                />
              </div>
            }
            @if (!wrappedMarketId()) {
              <span class="action-tip" [kcTooltip]="connectWalletTooltip()">
                <kc-button
                  variant="primary"
                  size="m"
                  text="Deploy wrapped trading"
                  [isDisabled]="!wrapperDeployReady()"
                  (buttonClick)="buildWrapperMarketDeploy()"
                />
              </span>
            }
            @if (wrappedMarketId()) {
              <kc-switch
                [options]="wrapModeOptions"
                [selectedValue]="wrapMode()"
                [isFullWidth]="true"
                size="m"
                ariaLabel="Wrap mode"
                (selectionChange)="setWrapMode($any($event.value))"
              />
            }
            @if (wrappedMarketId()) {
              <div class="wrapflow">
                <div class="wrapflow__side">
                  <span class="lbl">{{
                    wrapMode() === 'wrap'
                      ? 'Assets · KCC20'
                      : 'Trading · DEX Orderbook'
                  }}</span>
                  <strong>{{
                    (wrapMode() === 'wrap'
                      ? ownerCanonicalBalance()
                      : ownerWrappedBalance()
                    ) | kcc20TokenAmount: tokenDecimals()
                  }}</strong>
                </div>
                <div class="wrapflow__arrow">↓</div>
                <div class="wrapflow__side">
                  <span class="lbl">{{
                    wrapMode() === 'wrap'
                      ? 'Trading · DEX Orderbook'
                      : 'Assets · KCC20'
                  }}</span>
                  <strong class="accent">{{
                    (wrapMode() === 'wrap'
                      ? ownerWrappedBalance()
                      : ownerCanonicalBalance()
                    ) | kcc20TokenAmount: tokenDecimals()
                  }}</strong>
                </div>
              </div>
            }
            @if (wrappedMarketId()) {
              <div class="field">
                <label>{{
                  wrapMode() === 'wrap' ? 'Wrap amount' : 'Unwrap amount'
                }}</label>
                @if (wrapMode() === 'wrap') {
                  <kc-number-input
                    [ngModel]="wrapAmount()"
                    (ngModelChange)="wrapAmount.set($event)"
                    [enforceEthersFormat]="false"
                    [suffixTemplate]="amtSuffix"
                  />
                  <div class="preset-row">
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="25%"
                      [isDisabled]="!wrapPresetAvailable()"
                      (buttonClick)="setWrapAmountPreset(25)"
                    />
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="50%"
                      [isDisabled]="!wrapPresetAvailable()"
                      (buttonClick)="setWrapAmountPreset(50)"
                    />
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="75%"
                      [isDisabled]="!wrapPresetAvailable()"
                      (buttonClick)="setWrapAmountPreset(75)"
                    />
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="Max"
                      [isDisabled]="!wrapPresetAvailable()"
                      (buttonClick)="setWrapAmountPreset(100)"
                    />
                  </div>
                }
                @if (wrapMode() === 'unwrap') {
                  <kc-number-input
                    [ngModel]="unwrapAmount()"
                    (ngModelChange)="unwrapAmount.set($event)"
                    [enforceEthersFormat]="false"
                    [suffixTemplate]="amtSuffix"
                  />
                  <div class="preset-row">
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="25%"
                      [isDisabled]="!unwrapPresetAvailable()"
                      (buttonClick)="setUnwrapAmountPreset(25)"
                    />
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="50%"
                      [isDisabled]="!unwrapPresetAvailable()"
                      (buttonClick)="setUnwrapAmountPreset(50)"
                    />
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="75%"
                      [isDisabled]="!unwrapPresetAvailable()"
                      (buttonClick)="setUnwrapAmountPreset(75)"
                    />
                    <kc-button
                      variant="secondary"
                      size="s"
                      [isFullWidth]="true"
                      text="Max"
                      [isDisabled]="!unwrapPresetAvailable()"
                      (buttonClick)="setUnwrapAmountPreset(100)"
                    />
                  </div>
                }
              </div>
            }
            @if (wrappedMarketId()) {
              <div class="trade-actions">
                <!-- Stays live while a wrap/unwrap is in flight: every click
                     queues another flow in the wallet-operations scheduler
                     (#237); only validation disables it. Tooltip covers both
                     disable reasons (wallet not connected, or the backend
                     reporting the wrapper/market isn't ready yet) so the
                     button is never silently disabled — see
                     `wrapActionTooltip`. -->
                <span class="action-tip" [kcTooltip]="wrapActionTooltip()">
                  <kc-button
                    variant="primary"
                    size="m"
                    [text]="
                      wrapMode() === 'wrap'
                        ? wrapBalanceError()
                          ? 'Insufficient balance'
                          : 'Wrap'
                        : unwrapBalanceError()
                          ? 'Insufficient balance'
                          : 'Unwrap'
                    "
                    [isDisabled]="
                      wrapMode() === 'wrap'
                        ? !wrapDraftReady() || !!wrapBalanceError()
                        : !unwrapDraftReady() || !!unwrapBalanceError()
                    "
                    (buttonClick)="
                      wrapMode() === 'wrap' ? buildWrap() : buildUnwrap()
                    "
                  />
                </span>
              </div>
            }
            <p class="tiny">
              Wrapped market
              {{ wrappedMarketId() ? shortId(wrappedMarketId()) : '--' }}.
              Wrapping moves KCC20 into the wrapper reserve and issues a
              orderbook balance the orderbook can match.
            </p>
          </div>
        }
      </article>
    </div>

    <!-- Buy / Sell ticket -->
    <div class="kc-linear-right ticket-outer">
      <aside id="token-trade" class="tpanel ticket kc-linear-glow-right">
        <kc-switch
          class="trade-switch"
          [class.side--buy]="quoteSide() === 'buy'"
          [class.side--sell]="quoteSide() === 'sell'"
          [options]="quoteSideOptions"
          [selectedValue]="quoteSide()"
          [isFullWidth]="true"
          size="m"
          ariaLabel="Trade side"
          (selectionChange)="setQuoteSide($any($event.value))"
        />

        <kc-switch
          [options]="orderModeOptions"
          [selectedValue]="orderMode()"
          [isFullWidth]="true"
          size="s"
          ariaLabel="Order mode"
          (selectionChange)="setOrderMode($any($event.value))"
        />

        <div class="price-amount-row">
          @if (orderMode() === 'limit') {
            <div class="field">
              <label>Unit price <span class="hint">KAS / token</span></label>
              <kc-input
                [ngModel]="orderUnitPriceKas()"
                (ngModelChange)="setOrderUnitPriceKas($event)"
                (onblur)="refreshQuote()"
                [suffixTemplate]="kasSuffix"
              />
            </div>
          }
          @if (orderMode() === 'market') {
            <div class="field-spacer" aria-hidden="true"></div>
          }

          <div class="field">
            <label>
              Amount
              <span class="hint"
                >{{ availableLabel() }} {{ availableValue() }}</span
              >
            </label>
            <kc-number-input
              [ngModel]="quoteAmount()"
              (ngModelChange)="onQuoteAmountChange($event)"
              (onblur)="onQuoteAmountBlur()"
              [enforceEthersFormat]="false"
              [suffixTemplate]="amtSuffix"
            />

            <input
              class="amount-slider"
              type="range"
              [value]="quoteAmountSliderValue()"
              [disabled]="quoteAmountSliderDisabled()"
              [ariaLabel]="quoteSide() + ' amount percentage'"
              min="0"
              max="100"
              step="1"
              (input)="onQuoteAmountSliderInput(+$any($event.target).value)"
              (change)="onQuoteAmountSliderCommit(+$any($event.target).value)"
            />

            <div class="preset-row">
              <kc-button
                variant="secondary"
                size="s"
                [isFullWidth]="true"
                text="25%"
                (buttonClick)="setQuoteAmountPreset(25)"
              />
              <kc-button
                variant="secondary"
                size="s"
                [isFullWidth]="true"
                text="50%"
                (buttonClick)="setQuoteAmountPreset(50)"
              />
              <kc-button
                variant="secondary"
                size="s"
                [isFullWidth]="true"
                text="75%"
                (buttonClick)="setQuoteAmountPreset(75)"
              />
              <kc-button
                variant="secondary"
                size="s"
                [isFullWidth]="true"
                text="Max"
                (buttonClick)="setQuoteAmountPreset(100)"
              />
            </div>
          </div>
        </div>

        @if (ladderOrdersAvailable()) {
          <details
            class="ladder-spoiler"
            [open]="ladderExpanded()"
            (toggle)="onLadderSpoilerToggle($event)"
          >
            <summary>
              <span>Duplicate order</span>
              <kc-icon
                class="ladder-spoiler__chevron"
                iconClass="chevron-down"
                size="xs"
              />
            </summary>
            <div class="ladder">
              <div class="field">
                <kc-input
                  [ngModel]="'' + ladderCount()"
                  (ngModelChange)="setLadderCount($event)"
                  placeholder="0"
                />
              </div>
              <kc-switch
                [options]="ladderDirectionOptions"
                [selectedValue]="ladderDirection()"
                [isFullWidth]="true"
                size="s"
                ariaLabel="Order price step direction"
                (selectionChange)="setLadderDirection($any($event.value))"
              />
              <div class="preset-row ladder-presets">
                @for (preset of ladderPercentPresets; track preset) {
                  <kc-button
                    [variant]="
                      ladderPercentPresetSelected(preset)
                        ? 'primary'
                        : 'secondary'
                    "
                    size="s"
                    [isFullWidth]="true"
                    [text]="preset + '%'"
                    (buttonClick)="setLadderPercent(preset)"
                  />
                }
                <kc-input
                  class="ladder-custom"
                  size="s"
                  [maxLength]="6"
                  [ngModel]="
                    ladderPercentPresetSelected(+ladderPercent())
                      ? ''
                      : ladderPercent()
                  "
                  (ngModelChange)="setLadderPercent($event)"
                  placeholder="%"
                />
              </div>
              @if (ladderCount() > 1) {
                @if (ladderPreview(); as preview) {
                  <p class="ladder-preview">{{ preview }}</p>
                }
              }
            </div>
          </details>
        }

        @if (orderSummaryLine(); as summary) {
          <p class="order-summary-line">
            {{ summary }}
          </p>
        }

        @if (activeSweepQuote(); as sweepQuote) {
          @if ((sweepQuote.fills?.length ?? 0) > 1) {
            <details class="fills-spoiler">
              <summary>
                <span>See more order details</span>
                <kc-icon
                  class="fills-spoiler__chevron"
                  iconClass="chevron-down"
                  size="xs"
                />
              </summary>
              <dl class="dl fills-spoiler__list">
                @for (fill of sweepQuote.fills; track fill.orderId) {
                  <div>
                    <dt>{{ shortId(fill.orderId) }}</dt>
                    <dd>
                      {{ formatTokenBaseAmount(fill.tokenAmount) }}
                      @
                      {{
                        formatSompi(fill.unitPriceSompi, kasDisplayMaxDecimals)
                      }}
                    </dd>
                  </div>
                }
              </dl>
            </details>
          }
        }

        <dl class="dl">
          <div>
            <dt>
              {{
                activeMarketExecution()
                  ? 'Matched value'
                  : quoteSide() === 'buy'
                    ? 'Order total'
                    : 'Order value'
              }}
            </dt>
            <dd>
              {{
                formatSompi(
                  orderNotionalSompi()?.toString(),
                  kasDisplayMaxDecimals
                )
              }}
            </dd>
          </div>
          @if (activeFillOrderId() && activeFillUnitPriceSompi()) {
            <div>
              <dt>Matched price</dt>
              <dd>
                {{
                  formatSompi(activeFillUnitPriceSompi(), kasDisplayMaxDecimals)
                }}
              </dd>
            </div>
          }
          <div>
            <dt>
              {{
                activeMarketExecution() ? 'Protocol fee' : 'Est. protocol fee'
              }}
              ({{ protocolFeeRateLabel() }})
            </dt>
            <dd>
              {{
                formatSompi(
                  orderProtocolFeeSompi()?.toString(),
                  kasDisplayMaxDecimals
                )
              }}
            </dd>
          </div>
          @if (activeMarketExecution() && feePayerLabel(); as feePayer) {
            <div>
              <dt>Fee paid by</dt>
              <dd>{{ feePayer }}</dd>
            </div>
          }
          @if (feeTicketApplicable()) {
            <div>
              <dt>Coupon discount</dt>
              <dd [class.accent]="feeTicketActive()">
                {{ feeTicketDiscountLabel() }}
              </dd>
            </div>
          }
          <div>
            <dt>{{ settlementLabel() }}</dt>
            <dd class="accent">
              {{ formatSompi(settlementSompi(), kasDisplayMaxDecimals) }}
            </dd>
          </div>
        </dl>

        @if (feeTicketApplicable()) {
          <div class="ftrow">
            <span class="ftrow__label">
              Use Discount Coupon
              @if (feeTicketLeftLabel(); as leftLabel) {
                <small class="muted">{{ leftLabel }}</small>
              }
            </span>
            <kc-toggle
              size="sm"
              ariaLabel="Use Discount Coupon"
              [checked]="feeTicketActive()"
              [isDisabled]="!canUseFeeTicket()"
              (checkedChange)="useFeeTicket.set($event)"
            />
          </div>
        }

        <div class="trade-actions">
          <span
            class="action-tip"
            [kcTooltip]="orderActionDisabledReason() ?? ''"
          >
            <kc-button
              variant="primary"
              size="s"
              [text]="activeExecutionActionLabel()"
              [isLoading]="quoteLoading()"
              [isDisabled]="!!orderActionDisabledReason()"
              (buttonClick)="buildOrder()"
            />
          </span>
        </div>

        <!-- Wallet-operation queue owns signing after a ready inspect.
             Review dialog is no longer shown. -->
      </aside>
    </div>
  </div>
</section>

<ng-template #activityActionCell let-item>
  <span
    class="activity-action-cell"
    [class.dir-up]="item.direction === 'buy'"
    [class.dir-down]="item.direction === 'sell'"
    [class.dir-info]="item.direction === 'info'"
  >
    <span class="activity-action-cell__dot" aria-hidden="true"></span>
    <strong>{{ item.action }}</strong>
  </span>
</ng-template>

<ng-template #activityWhoCell let-item>
  <span class="activity-who-cell">
    <span class="mono activity-who-cell__label" [title]="item.whoFull">
      @if (item.whoUsesAddressTruncate) {
        {{ item.whoFull | truncateWalletAddress: 12 : 8 }}
      } @else {
        {{ item.who }}
      }
    </span>
    @if (item.whoFull && item.whoFull !== '--') {
      <button
        type="button"
        class="holder-copy-btn"
        [class.holder-copy-btn--copied]="activityWhoCopyCopied(item.key)"
        [attr.aria-label]="
          activityWhoCopyCopied(item.key) ? 'Copied' : 'Copy ' + item.whoFull
        "
        (click)="
          copyActivityWhoValue(item.key, item.whoFull); $event.stopPropagation()
        "
      >
        <kc-icon
          size="xs"
          class="holder-copy-icon"
          [iconClass]="activityWhoCopyCopied(item.key) ? 'check' : 'copy-03'"
          [isDefaultColor]="false"
        />
      </button>
    }
  </span>
</ng-template>

<ng-template #activityAmountCell let-item>
  <span class="mono">{{ item.amount }}</span>
</ng-template>

<ng-template #activityUnitPriceCell let-item>
  <span class="mono">{{ item.unitPrice }}</span>
</ng-template>

<ng-template #activityTotalCell let-item>
  <span
    class="mono activity-total-cell"
    [class.dir-up]="item.direction === 'buy'"
    [class.dir-down]="item.direction === 'sell'"
    [class.dir-info]="item.direction === 'info'"
    >{{ item.totalValue }}</span
  >
</ng-template>

<ng-template #activityTxCell let-item>
  <a
    class="activity-tx-link mono"
    [href]="explorerTxUrl(item.txid)"
    target="_blank"
    rel="noopener noreferrer"
    kcTooltip="View in explorer"
    [attr.aria-label]="'View transaction ' + item.txid + ' in explorer'"
  >
    {{ activityTxShort(item.txid) }}
    <svg
      class="activity-tx-link__icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  </a>
</ng-template>

<ng-template #activityTimeCell let-item>
  <span class="activity-time-cell">
    <span class="activity-time-cell__date">{{
      formatDateOnlyMs(item.timeMs)
    }}</span>
    <span class="activity-time-cell__time">{{
      formatTimeOnlyMs(item.timeMs)
    }}</span>
  </span>
</ng-template>

<ng-template #openOrderSideCell let-row="row">
  <span
    class="activity-action-cell"
    [class.dir-up]="openOrderDirection(row) === 'buy'"
    [class.dir-down]="openOrderDirection(row) === 'sell'"
  >
    <span class="activity-action-cell__dot" aria-hidden="true"></span>
    <strong>{{ displayOpenOrderSide(row) }}</strong>
  </span>
</ng-template>

<ng-template #openOrderAmountCell let-row="row">
  <span class="mono">{{
    openOrderAmount(row) | kcc20TokenAmount: tokenDecimals()
  }}</span>
</ng-template>

<ng-template #openOrderPriceCell let-row="row">
  <span class="mono">{{ priceBare(openOrderUnitPriceSompi(row)) }}</span>
</ng-template>

<ng-template #openOrderTotalCell let-row="row">
  <span class="mono">{{ openOrderTotalLabel(row) }}</span>
</ng-template>

<ng-template #openOrderTimeCell let-row="row">
  <span class="activity-time-cell">
    <span class="activity-time-cell__date">{{
      formatDateOnlyMs(row.createdAtMs)
    }}</span>
    <span class="activity-time-cell__time">{{
      formatTimeOnlyMs(row.createdAtMs)
    }}</span>
  </span>
</ng-template>

<ng-template #openOrderIdCell let-row="row">
  <span class="mono muted">{{ shortId(row.orderId) }}</span>
</ng-template>

<ng-template #openOrderCancelCell let-row="row">
  <button
    type="button"
    class="open-order-cancel"
    [disabled]="!canCancelOpenOrder(row)"
    [attr.aria-label]="'Cancel order ' + shortId(row.orderId)"
    (click)="buildCancelOpenOrder(row)"
  >
    <kc-icon
      iconClass="x-circle"
      size="xs"
      [isDefaultColor]="false"
      color="var(--sell)"
    />
  </button>
</ng-template>

<!-- Shared ticker suffix for the trade-cockpit amount inputs (kc-number-input).
          Wrapped in a styled span so it gets padding + platform font instead of
          rendering as a cramped bare label (KCC20-48). -->
<ng-template #amtSuffix>
  <span class="amt-suffix">{{ tradeTicker() }}</span>
</ng-template>

<!-- Static KAS suffix for the Unit price kc-input (priced in KAS per token,
          unlike the amount inputs above which suffix with the trade ticker). -->
<ng-template #kasSuffix>
  <span class="amt-suffix">KAS</span>
</ng-template>

<ng-template #pctSuffix>
  <span class="amt-suffix">%</span>
</ng-template>
